import { CurrencyAndProductVariants } from "../../../domain/projections/Wishlist";
import { WishlistRepository } from "../../../domain/repositories/WishlistRepository";
import { createHttpClients } from "../shared/createHttpClients";
import { WishlistDTO, mapWishlistItemDTOtoCurrencyAndItems } from "./responseMapper";

class WishlistRepositoryImpl implements WishlistRepository {
  private static instance: WishlistRepositoryImpl;

  private constructor() {}

  public static getInstance(): WishlistRepositoryImpl {
    if (!WishlistRepositoryImpl.instance) {
      WishlistRepositoryImpl.instance = new WishlistRepositoryImpl();
    }

    return WishlistRepositoryImpl.instance;
  }

  public async addVariant(variantId: string, auth: string, apiUrl: () => string): Promise<void> {
    try {
      const { httpPost } = createHttpClients(auth, apiUrl);
      await httpPost({
        endpoint: `/direct-buy/v1/add-to-wishlist`,
        body: { variantId },
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async getCurrencyAndProductVariants(auth: string, apiUrl: () => string): Promise<CurrencyAndProductVariants> {
    try {
      const { httpGet } = createHttpClients(auth, apiUrl);
      const response = await httpGet<WishlistDTO>({
        endpoint: `/direct-buy/v1/wishlist`,
      });
      return mapWishlistItemDTOtoCurrencyAndItems(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async removeVariant(auth: string, variantId: string, apiUrl: () => string): Promise<void> {
    try {
      const { httpDelete } = createHttpClients(auth, apiUrl);
      await httpDelete({
        endpoint: `/direct-buy/v1/remove-from-wishlist`,
        body: { variantId },
      });
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export { WishlistRepositoryImpl };
